module.exports = __webpack_public_path__ + "img/risks.274a37ee.svg";